import type { Meta, StoryObj } from "@storybook/react";

import type { ImageProps } from "@/ui/core";
import { Image } from "@/ui/core";

const ComponentMeta: Meta<ImageProps> = {
  title: "Core/Image",
  component: Image,
  argTypes: {
    accessibilityLabel: { control: "text" },
    contentFit: {
      control: "select",
      options: ["contain", "cover", "fill", "none", "scale-down"],
    },
    isRounded: { control: "boolean" },
    size: {
      control: "object",
    },
    testID: { control: "text" },
    uriSource: { control: "text" },
  },
  args: {
    accessibilityLabel: "Image",
    size: 300,
    testID: "storybook",
    uriSource: "https://i.pravatar.cc/300",
  },
};

type Story = StoryObj<ImageProps>;

const Primary: Story = {};

const WidthAndHeight: Story = {
  ...ComponentMeta,
  args: {
    size: {
      height: 100,
      width: 200,
    },
  },
};

const FullWidth = {
  ...ComponentMeta,
  args: {
    size: {
      height: 200,
      width: "100%",
    },
  },
};

const Rounded = {
  ...ComponentMeta,
  args: {
    isRounded: true,
  },
};

export { FullWidth, Primary, Rounded, WidthAndHeight };
export default ComponentMeta;
